import { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../context/AuthContext";

function CustomLanguageDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { selectedLang, setSelectedLang } = useAuth();

  const languages = [
    { code: "en", name: "English", flag: "🇬🇧" },
    { code: "ta", name: "Tamil", flag: "🇮🇳" },
    { code: "te", name: "Telugu", flag: "🇮🇳" },
    { code: "ml", name: "Malayalam", flag: "🇮🇳" },
    { code: "hi", name: "Hindi", flag: "🇮🇳" },
  ];

  const handleLanguageChange = (lang) => {
    setSelectedLang(lang);
    localStorage.setItem("LanguageCode", lang.code);
    setIsOpen(false);

    const selectElement = document.querySelector(".goog-te-combo");
    if (selectElement) {
      selectElement.value = lang.code;
      selectElement.dispatchEvent(new Event("change"));
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      // Check if the translate banner frame exists and is visible
      const translateFrame = document.querySelector(".goog-te-banner-frame");
      const translateBanner =
        translateFrame?.contentDocument?.querySelector(".goog-te-banner");

      // If banner doesn't exist or is hidden, reset to "Languages"
      if (
        !translateFrame ||
        !translateBanner ||
        translateFrame.style.display === "none"
      ) {
        // setSelectedLang(null);
      }

      // Also check if body no longer has the translated class
      const bodyClasses = document.body.className;
      if (!bodyClasses.includes("translated")) {
        // setSelectedLang(null);
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  // Hide breadcrumbs while the custom language dropdown is open
  useEffect(() => {
    const breadcrumbs = document.querySelector(".breadcrumbs");
    if (!breadcrumbs) return;

    if (isOpen) {
      // store previous display so we can restore it
      breadcrumbs.dataset._prevDisplay = breadcrumbs.style.display || "";
      breadcrumbs.style.display = "none";
    } else {
      // restore previous display value
      breadcrumbs.style.display = breadcrumbs.dataset._prevDisplay || "";
      delete breadcrumbs.dataset._prevDisplay;
    }

    return () => {
      // ensure it's restored if component unmounts while open
      breadcrumbs.style.display = breadcrumbs.dataset._prevDisplay || "";
      delete breadcrumbs.dataset._prevDisplay;
    };
  }, [isOpen]);

  return (
    <div className="custom-language-wrapper" ref={dropdownRef}>
      <div id="google_translate_element" style={{ display: "none" }}></div>

      <div
        className="custom-language-button"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="language-name">
          {selectedLang ? selectedLang.name : "Languages"}
        </span>
        <FontAwesomeIcon
          icon={faChevronDown}
          className={`language-arrow ${isOpen ? "open" : ""}`}
        />
      </div>

      {isOpen && (
        <div className="custom-language-menu">
          {languages.map((lang) => (
            <div
              key={lang.code}
              onClick={() => handleLanguageChange(lang)}
              className={`language-option ${
                selectedLang?.code === lang.code ? "active" : ""
              }`}
            >
              <span className="option-name">{lang.name}</span>
              {selectedLang?.code === lang.code && (
                <span className="check-mark">✓</span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default CustomLanguageDropdown;
